import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateDepositResponse } from '../../models/deposits.model';
import { AdditionalPACData } from '../../models/additional-pac-data.model';

@Injectable({
  providedIn: 'root'
})
export class CourtDepositService {
  constructor(private readonly http: HttpClient) {}

  saveCourtDeposit(additionalPACData: AdditionalPACData): Observable<CreateDepositResponse> {
    const appToken = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${appToken}`
    });

    return this.http.post<CreateDepositResponse>('api/deposit-payment', additionalPACData, { headers });
  }
}
